import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';

import { COLORS } from '../constants';


export default function RadioBtn({ changeValue, text, style, selected }) {
  return (
    <TouchableOpacity
      style={styles.btn}
      onPress={changeValue}
    >

      <View style={[{
        height: 24,
        width: 24,
        borderRadius: 12,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 20,
        marginRight: 15,
      }, selected ? {
        borderColor: COLORS.accent,
      } : {
        borderColor: COLORS.secondary,

      }]}>
        {
          selected ?
            <View style={{
              height: 12,
              width: 12,
              borderRadius: 6,
              backgroundColor: COLORS.accent,
            }} />
            : null
        }
      </View>

      <Text style={[{
        color: COLORS.secondary,
        // width: 50,
        fontSize: 18,
      }, selected ? {
        color: COLORS.primary,

      } : null]}>{text}</Text>

    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  radioLbl: {
    color: COLORS.secondary,
    // width: 50,
    fontSize: 18,
  },
  btn: {
    flexDirection: 'row', 
    alignItems: 'center',
    // marginTop: 20,
  },
  // txt: { fontSize: 30, color: 'white' },
  // tick: { position: 'absolute', right: 0, height: 30, width: 30, marginRight: 30, tintColor: 'white' }
});